PJQ.views.dailyReports.DeliveryManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Delivery-Management')
	},
	events: {
		'click .add-delivery': 'addClicked',
		'click .edit-delivery': 'editClicked',
		'click .delete-delivery': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminDeliveries');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddDeliveries') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.delivery-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Delivery" to create a new delivery' : 'No deliveries were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editDelivery(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editDelivery(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editDelivery(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteDelivery(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "40px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{
					"data": "",
					"title": "From",
					"searchable": false,
					"width": "20%",
					"render": function (data, type, row) {
						let result = 'Not set';
						if (row.deliveryFrom != null) {
							result = PJQ.helpers.contacts.getContactAnchor({
								id: row.deliveryFrom.id,
								name: row.deliveryFrom.get('companyName')
							});
						}
						else {
							let deliveryFromName = row.get('deliveryFromName');
							if (_.size(deliveryFromName) > 0) {
								result = deliveryFromName;
							}
						}
						return result;
					}
				},
				{
					"data": "attributes.time",
					"title": "Time",
					"searchable": false,
					"width": "80px",
					"render": function (data) {
						if (data != null) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME);
						}
						return 'Not Set';
					}
				},
				{
					"data": "attributes.trackingNumber",
					"title": "Tracking Number",
					"width": "15%"
				},
				{
					"data": "attributes.purchaseOrderNumber",
					"title": "PO Number",
					"width": "15%"
				},
				{
					"data": "attributes.contents",
					"title": "Contents",
					"orderable": false
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-delivery ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-delivery ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-delivery ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newDelivery = new PJQ.models.dailyReports.Delivery({
			dailyReportId: this.options.dailyReport.id,
			time: new Date(),
			trackingNumber: '',
			purchaseOrderNumber: '',
			contents: '',
			notes: ''
		});
		this.editDelivery(newDelivery);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.editDelivery(row.data());
	},
	editDelivery: function (delivery) {
		new PJQ.views.dailyReports.EditDeliveryModal({
			model: delivery,
			project: this.options.project,
			isLocked: this.options.isLocked,
			onSave: _.bind(function (delivery) {
				if (delivery.hasChanged() || delivery.isNew()) {
					if (delivery.isNew()) {
						this.collection.add(delivery);
						this.dataTable.addRow(delivery);
					}
					delivery.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (delivery) {
				if (delivery.hasChanged()) {
					delivery.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (delivery) {
				if (delivery.id > 0) {
					let row = this.dataTable.getRow(delivery.cid);
					this.collection.remove(delivery);
					delivery.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteDelivery(row);
	},
	deleteDelivery: function (row) {
		let delivery = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this delivery?",
			onDelete: _.bind(function () {
				this.collection.remove(delivery);
				delivery.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditDeliveryModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Delivery'),
		maxWidth: 800
	},
	events: {
		'click .delivery-from-edit': 'editDeliveryFrom',
		'click .delivery-save': 'onSave',
		'click .delivery-close': 'close',
		'click .delivery-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminDeliveries');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddDeliveries') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.delivery-from'),
				context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
				selectedContact: this.model.deliveryFrom,
				isSingleChoice: true,
				isReadOnly: !this.options.canEdit,
				addButton: this.$('.btn-edit-delivery-from'),
				onChange: _.bind(function (selectedContact) {
					this.model.deliveryFrom = selectedContact;
					this.model.set('deliveryFromName', '');
					this.model.isDirty = true;
					this.renderDeliveryFrom();
				}, this)
			});
		}
		this.renderDeliveryFrom();

		new PJQ.inputs.Datepicker({
			el: this.$('.delivery-time'),
			isTimeOnly: true,
			datepickerOptions: {
				defaultDate: this.model.get('time')
			},
			onChange: _.bind(function (newTime) {
				let currentDeliveryTime = this.model.get('time');
				if (currentDeliveryTime == null || PJQ.helpers.dateHelpers.checkTimesDifferent(newTime, new Date(currentDeliveryTime))) {
					this.model.set('time', newTime);
				}
			}, this)
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.delivery-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	renderDeliveryFrom: function () {
		let $contactSelect = this.$('.delivery-from'),
			$contactName = this.$('.delivery-from-name');
		if (this.model.deliveryFrom != null) {
			$contactName.addClass('hidden');
			$contactSelect.removeClass('hidden');
		}
		else {
			$contactSelect.addClass('hidden');
			$contactName.removeClass('hidden');
		}
	},
	onSave: function () {
		if (this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this delivery?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});
